// Search Bar Component

import { updateFilter } from './BookmarkList.js';

export function renderSearchBar() {
  return `
    <div class="search-bar">
      <div class="search-input-wrapper">
        <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <input
          type="text"
          id="search-input"
          class="search-input"
          placeholder="Suche nach Titel, URL oder Beschreibung..."
        >
      </div>

      <div class="filter-controls">
        <select id="category-filter" class="filter-select">
          <option value="">Alle Kategorien</option>
        </select>

        <div class="tag-filter-dropdown">
          <button id="tag-filter-btn" class="filter-btn">
            Tags filtern
            <span id="tag-filter-count"></span>
          </button>
          <div id="tag-filter" class="tag-filter-content"></div>
        </div>

        <select id="sort-select" class="filter-select">
          <option value="created_at:desc">Neueste zuerst</option>
          <option value="created_at:asc">Älteste zuerst</option>
          <option value="title:asc">Titel (A-Z)</option>
          <option value="title:desc">Titel (Z-A)</option>
          <option value="url:asc">URL (A-Z)</option>
          <option value="url:desc">URL (Z-A)</option>
        </select>
      </div>
    </div>
  `;
}

export function initSearchBar() {
  const searchInput = document.getElementById('search-input');
  const categoryFilter = document.getElementById('category-filter');
  const sortSelect = document.getElementById('sort-select');
  const tagFilterBtn = document.getElementById('tag-filter-btn');
  const tagFilterContent = document.getElementById('tag-filter');

  // Search input with debounce
  let searchTimeout;
  searchInput?.addEventListener('input', (e) => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      updateFilter({ search: e.target.value });
    }, 300);
  });

  // Category filter
  categoryFilter?.addEventListener('change', (e) => {
    const categoryId = e.target.value ? parseInt(e.target.value) : null;
    updateFilter({ categoryId });
  });

  // Sort select
  sortSelect?.addEventListener('change', (e) => {
    const [sortBy, sortOrder] = e.target.value.split(':');
    updateFilter({ sortBy, sortOrder });
  });

  // Tag filter dropdown toggle
  tagFilterBtn?.addEventListener('click', () => {
    tagFilterContent?.classList.toggle('show');
  });

  // Tag filter checkboxes
  tagFilterContent?.addEventListener('change', (e) => {
    if (e.target.type === 'checkbox') {
      const selectedTags = Array.from(
        tagFilterContent.querySelectorAll('input[type="checkbox"]:checked')
      ).map(cb => parseInt(cb.value));

      updateFilter({ tagIds: selectedTags });
      updateTagFilterCount(selectedTags.length);
    }
  });

  // Close tag filter dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.tag-filter-dropdown')) {
      tagFilterContent?.classList.remove('show');
    }
  });
}

function updateTagFilterCount(count) {
  const countEl = document.getElementById('tag-filter-count');
  if (countEl) {
    countEl.textContent = count > 0 ? `(${count})` : '';
  }
}
